'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _nodePolyglot = require('node-polyglot');

var _nodePolyglot2 = _interopRequireDefault(_nodePolyglot);

var _reactRedux = require('react-redux');

var _reactDocumentMeta = require('react-document-meta');

var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);

var _password = require('redux/modules/password');

var passwordActions = _interopRequireWildcard(_password);

var _reactRouter = require('react-router');

var _components = require('components');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Email = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    error: state.password.error,
    loading: state.password.loading,
    status: state.password.status,
    user: state.auth.user
  };
}, (0, _extends3.default)({}, passwordActions)), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Email, _Component);

  function Email(props, context, updater) {
    (0, _classCallCheck3.default)(this, Email);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Email.__proto__ || (0, _getPrototypeOf2.default)(Email)).call(this, props, context, updater));

    _this.state = {
      showError: false,
      showSuccess: false
    };
    return _this;
  }

  (0, _createClass3.default)(Email, [{
    key: 'handleSubmit',
    value: function handleSubmit(event) {
      var _this2 = this;

      event.preventDefault();
      var email = this.props.email; // eslint-disable-line no-shadow

      var emailVal = this.refs.email;

      email(emailVal.value.trim()).then(function (res) {
        if (res.type === 'caligram/password/EMAIL_FAIL') {
          _this2.setState({ showError: true, showSuccess: false });
        } else if (res.type === 'caligram/password/EMAIL_SUCCESS') {
          _this2.setState({ showError: false, showSuccess: true });
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          loading = _props.loading,
          error = _props.error,
          status = _props.status,
          user = _props.user;

      var locale = user ? user.lang : 'fr';
      var phrases = require('./../../locales/' + locale + '/password.js');

      var polyglot = new _nodePolyglot2.default({
        locale: locale,
        phrases: phrases
      });
      var _state = this.state,
          showError = _state.showError,
          showSuccess = _state.showSuccess;


      var logoImage = require('../../assets/images/logo-caligram.svg');

      return _react2.default.createElement(
        'div',
        { className: '' },
        _react2.default.createElement(_components.BodyStyle, { style: { backgroundColor: '#EFEEEA' }, className: 'auth' }),
        _react2.default.createElement(_reactDocumentMeta2.default, { title: polyglot.t('password.email.meta_title') }),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'text-center' },
            _react2.default.createElement('img', { className: 'logo', src: logoImage, alt: 'Caligram' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'form-reset col-xs-8 col-xs-offset-2 col-sm-6 col-sm-offset-3 col-lg-4 col-lg-offset-4' },
            _react2.default.createElement(
              'div',
              { className: 'actions' },
              _react2.default.createElement('i', { className: 'icon-cg-arrow-left text-primary' }),
              ' ',
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/auth/login' },
                polyglot.t('password.button.login')
              )
            ),
            _react2.default.createElement(
              'h1',
              null,
              polyglot.t('password.email.title')
            ),
            showSuccess && _react2.default.createElement(
              'span',
              null,
              status
            ),
            !showSuccess && _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'p',
                null,
                polyglot.t('password.email.help')
              ),
              showError && error && _react2.default.createElement(
                'div',
                { className: 'alert alert-danger', role: 'alert' },
                error.email && _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement('span', { className: 'glyphicon glyphicon-exclamation-sign', 'aria-hidden': 'true' }),
                  _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    'Error:'
                  ),
                  error.email
                ),
                showError && !error.email && _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement('span', { className: 'glyphicon glyphicon-exclamation-sign', 'aria-hidden': 'true' }),
                  _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    'Error:'
                  ),
                  error.message || ' ' + error
                )
              ),
              _react2.default.createElement(
                'form',
                { onSubmit: this.handleSubmit.bind(this) },
                _react2.default.createElement(
                  'div',
                  { className: 'form-group' },
                  _react2.default.createElement(
                    'label',
                    null,
                    polyglot.t('password.email.form.email')
                  ),
                  _react2.default.createElement('input', { ref: 'email', type: 'text', className: 'form-control', defaultValue: '' })
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  'button',
                  {
                    type: 'submit',
                    className: 'btn btn-primary btn-block',
                    disabled: loading
                  },
                  polyglot.t('password.email.form.submit')
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Email;
}(_react.Component), _class2.propTypes = {
  email: _propTypes2.default.func,
  error: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
  loading: _propTypes2.default.bool,
  status: _propTypes2.default.any,
  user: _propTypes2.default.object
}, _temp)) || _class);
exports.default = Email;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Password/Email.js
// module id = 2270
// module chunks = 0